<template>
  <div>
    {{"hai"}}
    <div class="text-center" v-if="overlay">
      <v-overlay :model-value="overlay" class="align-center justify-center">
        <v-progress-circular
          color="primary"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </div>
    <common ref="common" />
    <v-row>
      <v-col cols="12">
        <v-card>
          <!-- <v-tabs
            slider-color="primary"
            color="primary"
            dark
            centered
            icons-and-text
          >
            <v-tab
              >Orders
              <v-icon large>
                mdi-checkbox-marked-circle-outline
              </v-icon>
            </v-tab>
            <v-tab
              >Kitchen Display
              <v-icon large>
                mdi-clipboard-text
              </v-icon>
            </v-tab> -->

          <!-- <v-tab-item v-for="n in 3" :key="n"> -->
          <v-container fluid>
            <!-- <v-card> -->
            <!-- <v-card class="ma-0 pa-0" v-if="n == 1"> -->
            <!-- <v-card v-if="n == 2"> </v-card> -->
          </v-container>
          <!-- </v-tab-item> -->
          <!-- </v-tabs> -->
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
import common from "@/components/tools/common";
// import orderDetails from "./orderDetails.vue";
export default {
  components: { common },
  data() {
    return {
      overlay: false,
      totalPages: 0,
      filterModel: {
        sort: "name",
        page: 1,
        per_page: 100,
        filter: "",
        id: 0,
        param: "",
        where: null,
        downloadFile: false,
        filterData: "",
        enableSignInValidation: false,
        signIn: true,
        credit: true,
      },
    };
  },
  created() {
    this.clear();
  },
  mounted() {
    this.overlay = true;
    this.overlay = false;
  },
  methods: {
    loadMore() {
      this.filterModel.page += 1;
    },
    filter() {
      this.filterModel.page = 1;
    },
    clear() {
    },
  },
};
</script>
<style>
.middle {
  writing-mode: horizontal-tb;
  display: inline-block;
  text-align: center;
  width: 100%;
}
</style>
<style lang="scss">
.spansize {
  font-size: 0.75rem;
}
.spansize2 {
  font-size: 1rem;
}
</style>
